import React from 'react';
import classes from './index.module.css';
const ContentLoader = ({ width = '15px', height = '15px', classNames='' }) => {
  return <span style={{ width, height }} className={`${classes.loader} ${classNames}`}></span>;
};
export default ContentLoader;
